import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PermissionMatrix, ProjectRole } from '../models/access.models';

/**
 * Экшены слайса `access` (F1).
 * Матрица текущего пользователя грузится при входе в проект (`GET /my-permissions/`).
 */
export const AccessActions = createActionGroup({
  source: 'Access',
  events: {
    'Load Permissions': props<{ projectId: number }>(),
    'Load Permissions Success': props<{ projectId: number; matrix: PermissionMatrix; role: ProjectRole | null }>(),
    'Load Permissions Failure': props<{ projectId: number }>(),
    'Clear Permissions': emptyProps(),
  },
});
